import React from 'react'
import {ReportsTable} from './ReportsTable'
// import {useIntl} from 'react-intl'

const Reports = ({
  setTabKey,
  isActive,
  setIsActive,
  selectedReportTypeFilter,
  search,
  getAllTemplate
}: any) => {
  // const {formatMessage} = useIntl()

  return (
    <>
      <div className=' rounded-2 mt-4'>
        <ReportsTable
          setTabKey={setTabKey}
          isActive={isActive}
          setIsActive={setIsActive}
          selectedReportTypeFilter={selectedReportTypeFilter}
          search={search}
        />
      </div>
    </>
  )
}

export default Reports
